export default __webpack_public_path__ + "3f5e6ac9ec361f24098f89b3d9735b3b.png";